import { defineMessages } from "react-intl";
const messages = defineMessages({
    updateSpaceSettingsSuccess: {
        id: "app.space.details.settings.amenity.update.success.text",
        defaultMessage: "Space settings updated successfully.",
    },
    updateSpaceTitle: {
        id: "app.space.details.settings.amenity.title.text",
        defaultMessage: "Space Settings",
    },
    update: {
        id: "app.space.details.settings.amenity.update.button.text",
        defaultMessage: "Save",
    },
    updateFormAmenityLabel: {
        id: "app.space.details.settings.amenity.update.form.amenityLabel.text",
        defaultMessage: "Amenity Name",
    },
    updateFormAmenityLabelRequired: {
        id: "app.space.details.settings.amenity.update.form.amenityLabel.required.text",
        defaultMessage: "Amenity's name is required",
    },
});
export default messages;
